import { render, staticRenderFns } from "./AssessmentSection4.vue?vue&type=template&id=0b1068a1&scoped=true&"
import script from "./AssessmentSection4.vue?vue&type=script&lang=ts&"
export * from "./AssessmentSection4.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentSection4.vue?vue&type=style&index=0&id=0b1068a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1068a1",
  null
  
)

export default component.exports